const white = "#ffffff";
const white$1 = {
  white
};
export {
  white$1 as default,
  white
};
//# sourceMappingURL=index.es10.js.map
